// Language translations for HandyBayani
// Supports: English (en), Tagalog (tl)

export const translations = {
  en: {
    // Common
    app_name: "HandyBayani",
    tagline: "Your Trusted Home Service Heroes",
    loading: "Loading...",
    save: "Save",
    cancel: "Cancel",
    delete: "Delete",
    edit: "Edit",
    close: "Close",
    confirm: "Confirm",
    back: "Back",
    next: "Next",
    submit: "Submit",
    search: "Search",
    filter: "Filter",
    all: "All",
    none: "None",
    yes: "Yes",
    no: "No",
    
    // Navigation
    nav_home: "Home",
    nav_services: "Services",
    nav_bookings: "My Bookings",
    nav_wallet: "Wallet",
    nav_profile: "Profile",
    nav_logout: "Logout",
    nav_login: "Login",
    nav_register: "Register",
    
    // Auth
    login_title: "Welcome Back",
    login_subtitle: "Sign in to your account",
    login_email: "Email",
    login_password: "Password",
    login_phone: "Phone Number",
    login_otp: "Enter OTP",
    login_button: "Sign In",
    login_with_phone: "Sign in with Phone",
    login_with_email: "Sign in with Email",
    login_no_account: "Don't have an account?",
    register_title: "Create Account",
    register_subtitle: "Join HandyBayani today",
    register_name: "Full Name",
    register_button: "Create Account",
    register_has_account: "Already have an account?",
    register_as_provider: "Register as Service Provider",
    register_as_customer: "Register as Customer",
    
    // Services
    services_title: "Our Services",
    services_subtitle: "Professional home services at your fingertips",
    service_book_now: "Book Now",
    service_from: "Starting from",
    service_duration: "Est. Duration",
    service_rating: "Rating",
    
    // Booking
    booking_title: "Book a Service",
    booking_select_date: "Select Date",
    booking_select_time: "Select Time",
    booking_select_address: "Select Address",
    booking_add_notes: "Additional Notes (optional)",
    booking_summary: "Booking Summary",
    booking_service_fee: "Service Fee",
    booking_add_ons: "Add-ons",
    booking_total: "Total",
    booking_confirm: "Confirm Booking",
    booking_success: "Booking Confirmed!",
    booking_finding_provider: "Finding a provider for you...",
    
    // Booking Status
    status_pending: "Pending",
    status_accepted: "Accepted",
    status_on_the_way: "On the Way",
    status_arrived: "Arrived",
    status_in_progress: "In Progress",
    status_completed: "Completed",
    status_cancelled: "Cancelled",
    status_finding_provider: "Finding Provider",
    
    // Wallet
    wallet_title: "My Wallet",
    wallet_balance: "Current Balance",
    wallet_topup: "Top Up",
    wallet_transactions: "Transaction History",
    wallet_no_transactions: "No transactions yet",
    
    // Profile
    profile_title: "My Profile",
    profile_edit: "Edit Profile",
    profile_addresses: "My Addresses",
    profile_referral: "Referral Program",
    profile_referral_code: "Your Referral Code",
    profile_referral_share: "Share and earn ₱100 for each friend!",
    
    // Provider
    provider_dashboard: "Dashboard",
    provider_jobs: "Jobs",
    provider_earnings: "Earnings",
    provider_online: "Go Online",
    provider_offline: "Go Offline",
    provider_accept_job: "Accept Job",
    provider_decline_job: "Decline",
    provider_start_job: "Start Job",
    provider_complete_job: "Complete Job",
    
    // Reviews
    review_title: "Leave a Review",
    review_rating: "Rate your experience",
    review_comment: "Your feedback (optional)",
    review_submit: "Submit Review",
    review_thanks: "Thank you for your feedback!",
    
    // Errors
    error_generic: "Something went wrong. Please try again.",
    error_network: "Network error. Check your connection.",
    error_unauthorized: "Please login to continue.",
    error_not_found: "Not found.",
    
    // Success messages
    success_saved: "Changes saved successfully!",
    success_booking: "Booking created successfully!",
    success_review: "Review submitted successfully!",
    
    // Landing Page
    landing_hero_title: "Home Services Made Easy",
    landing_hero_subtitle: "Book trusted professionals for all your home needs",
    landing_cta: "Get Started",
    landing_how_it_works: "How It Works",
    landing_step1_title: "Choose a Service",
    landing_step1_desc: "Browse our wide range of home services",
    landing_step2_title: "Book a Time",
    landing_step2_desc: "Select a convenient date and time",
    landing_step3_title: "Relax",
    landing_step3_desc: "Our verified bayani will handle the rest",
    landing_testimonials: "What Our Customers Say",
    landing_download: "Download Invoice",
    landing_receipt: "Download Receipt",
  },
  
  tl: {
    // Common
    app_name: "HandyBayani",
    tagline: "Ang Iyong Mapagkakatiwalaang Bayani sa Tahanan",
    loading: "Naglo-load...",
    save: "I-save",
    cancel: "Kanselahin",
    delete: "Burahin",
    edit: "I-edit",
    close: "Isara",
    confirm: "Kumpirmahin",
    back: "Bumalik",
    next: "Susunod",
    submit: "Isumite",
    search: "Maghanap",
    filter: "I-filter",
    all: "Lahat",
    none: "Wala",
    yes: "Oo",
    no: "Hindi",
    
    // Navigation
    nav_home: "Home",
    nav_services: "Mga Serbisyo",
    nav_bookings: "Mga Booking",
    nav_wallet: "Wallet",
    nav_profile: "Profile",
    nav_logout: "Mag-logout",
    nav_login: "Mag-login",
    nav_register: "Mag-register",
    
    // Auth
    login_title: "Maligayang Pagbabalik",
    login_subtitle: "Mag-sign in sa iyong account",
    login_email: "Email",
    login_password: "Password",
    login_phone: "Numero ng Telepono",
    login_otp: "Ilagay ang OTP",
    login_button: "Mag-sign In",
    login_with_phone: "Mag-sign in gamit ang Telepono",
    login_with_email: "Mag-sign in gamit ang Email",
    login_no_account: "Wala pang account?",
    register_title: "Gumawa ng Account",
    register_subtitle: "Sumali sa HandyBayani ngayon",
    register_name: "Buong Pangalan",
    register_button: "Gumawa ng Account",
    register_has_account: "May account na?",
    register_as_provider: "Mag-register bilang Service Provider",
    register_as_customer: "Mag-register bilang Customer",
    
    // Services
    services_title: "Mga Serbisyo Namin",
    services_subtitle: "Propesyonal na serbisyo sa tahanan sa iyong mga kamay",
    service_book_now: "Mag-book Ngayon",
    service_from: "Simula sa",
    service_duration: "Tinatayang Tagal",
    service_rating: "Rating",
    
    // Booking
    booking_title: "Mag-book ng Serbisyo",
    booking_select_date: "Pumili ng Petsa",
    booking_select_time: "Pumili ng Oras",
    booking_select_address: "Pumili ng Address",
    booking_add_notes: "Karagdagang Notes (opsyonal)",
    booking_summary: "Buod ng Booking",
    booking_service_fee: "Service Fee",
    booking_add_ons: "Mga Add-on",
    booking_total: "Kabuuan",
    booking_confirm: "Kumpirmahin ang Booking",
    booking_success: "Nakumpirma ang Booking!",
    booking_finding_provider: "Naghahanap ng provider para sa iyo...",
    
    // Booking Status
    status_pending: "Naghihintay",
    status_accepted: "Tinanggap",
    status_on_the_way: "Papunta Na",
    status_arrived: "Dumating Na",
    status_in_progress: "Isinasagawa",
    status_completed: "Tapos Na",
    status_cancelled: "Kinansela",
    status_finding_provider: "Naghahanap ng Provider",
    
    // Wallet
    wallet_title: "Aking Wallet",
    wallet_balance: "Kasalukuyang Balanse",
    wallet_topup: "Mag-top Up",
    wallet_transactions: "Kasaysayan ng Transaksyon",
    wallet_no_transactions: "Wala pang transaksyon",
    
    // Profile
    profile_title: "Aking Profile",
    profile_edit: "I-edit ang Profile",
    profile_addresses: "Mga Address Ko",
    profile_referral: "Referral Program",
    profile_referral_code: "Iyong Referral Code",
    profile_referral_share: "Mag-share at kumita ng ₱100 bawat kaibigan!",
    
    // Provider
    provider_dashboard: "Dashboard",
    provider_jobs: "Mga Trabaho",
    provider_earnings: "Mga Kita",
    provider_online: "Mag-Online",
    provider_offline: "Mag-Offline",
    provider_accept_job: "Tanggapin ang Trabaho",
    provider_decline_job: "Tanggihan",
    provider_start_job: "Simulan ang Trabaho",
    provider_complete_job: "Tapusin ang Trabaho",
    
    // Reviews
    review_title: "Mag-iwan ng Review",
    review_rating: "I-rate ang iyong karanasan",
    review_comment: "Iyong feedback (opsyonal)",
    review_submit: "Isumite ang Review",
    review_thanks: "Salamat sa iyong feedback!",
    
    // Errors
    error_generic: "May nangyaring mali. Subukan ulit.",
    error_network: "Network error. Suriin ang iyong koneksyon.",
    error_unauthorized: "Mag-login upang magpatuloy.",
    error_not_found: "Hindi nahanap.",
    
    // Success messages
    success_saved: "Matagumpay na na-save ang mga pagbabago!",
    success_booking: "Matagumpay na nagawa ang booking!",
    success_review: "Matagumpay na naisumite ang review!",
    
    // Landing Page
    landing_hero_title: "Mga Serbisyo sa Tahanan, Pinadali",
    landing_hero_subtitle: "Mag-book ng mga mapagkakatiwalaang propesyonal para sa lahat ng pangangailangan sa tahanan",
    landing_cta: "Magsimula",
    landing_how_it_works: "Paano Ito Gumagana",
    landing_step1_title: "Pumili ng Serbisyo",
    landing_step1_desc: "Mag-browse sa aming malawak na hanay ng mga serbisyo sa tahanan",
    landing_step2_title: "Mag-book ng Oras",
    landing_step2_desc: "Pumili ng maginhawang petsa at oras",
    landing_step3_title: "Magpahinga",
    landing_step3_desc: "Ang aming verified na bayani ang bahala sa lahat",
    landing_testimonials: "Ano ang Sinasabi ng Aming Mga Customer",
    landing_download: "I-download ang Invoice",
    landing_receipt: "I-download ang Receipt",
  }
};

export const getTranslation = (lang, key) => {
  return translations[lang]?.[key] || translations['en'][key] || key;
};

export const supportedLanguages = [
  { code: 'en', name: 'English', nativeName: 'English' },
  { code: 'tl', name: 'Tagalog', nativeName: 'Tagalog' }
];
